<template>
  <div>
    <fieldset>
      <legend class="text-blue ts-font-robot">
        {{ $t('promotion.condition') }}
        <Tooltip placement="top">
          <Icon type="ios-information-circle-outline" size="17" />
          <div slot="content">
            <div class="ts-text-xs">
              {{ $t('promotion.condition') }}
            </div>
          </div>
        </Tooltip>
      </legend>
      <div class="overflow-auto ts-max-h-40">
        <div class="ts-flex ts-justify-end ts-pb-1 ts-mt--1">
          <Button type="info" size="small" @click="onApplyAll">{{
            $t('promotion.applyAll')
          }}</Button>
        </div>
        <div class="table-ui-detail">
          <table>
            <thead>
              <tr>
                <th width="2%" class="ts-text-center">{{ $t('no') }}</th>
                <th width="10%">{{ $t('promotion.productGroup') }}</th>
                <th width="10%">{{ $t('promotion.barcode') }}</th>
                <th width="20%">{{ $t('promotion.product') }}</th>
                <th width="10%">{{ $t('promotion.discountType') }}</th>
                <th width="10%">{{ $t('promotion.discountRate') }}</th>
                <th width="10%">{{ $t('promotion.incentiveType') }}</th>
                <th width="10%">{{ $t('promotion.incentiveRate') }}</th>
                <th width="2%" class="ts-text-center">
                  <a href="#" @click.prevent="addItem">
                    <i class="fa fa-plus"></i>
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="model.condition.length == 0">
                <td colspan="9" class="ts-text-center ts-p-3 ts-space-x-1">
                  <i class="fa fa-folder-open ts-text-gray-200"></i>
                  <label class="ts-text-gray-400">
                    {{ $t('noData') }}
                  </label>
                </td>
              </tr>
              <tr v-for="(item, index) in model.condition" :key="index">
                <td class="ts-whitespace-no-wrap ts-text-center">
                  {{ index + 1 }}
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  {{ getProduct(item.product_id) ? getProduct(item.product_id).pro_group_name_en : 'N/A' }}
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  {{ getProduct(item.product_id) ? getProduct(item.product_id).barcode : 'N/A' }}
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  {{ getProduct(item.product_id) ? getProduct(item.product_id).product_name_en : 'N/A' }}
                </td>
                <td>
                  <a-select v-model="item.discount_type" class="ts-w-full" style="min-width: 50px"
                    @change="onChangeItem(item)">
                    <a-select-option value="%">%</a-select-option>
                    <a-select-option :value="getDiscountCurrency(item.input_currency_id)">
                      {{ getDiscountCurrency(item.input_currency_id) }}
                    </a-select-option>
                  </a-select>
                </td>
                <td>
                  <input v-if="item.discount_type == '%'" ref="discountRate" type="number"
                    v-model.number="item.input_discount_rate" class="form-control" @change="onChangeItem(item)" />
                  <ts-currency-converter-input v-else :input_amount.sync="item.input_discount_rate"
                    :amount.sync="item.discount_rate" :input_currency_id.sync="item.input_currency_id"
                    :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                    :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 120px;" />
                </td>
                <td>
                  <a-select v-model="item.incentive_type" class="ts-w-full" style="min-width: 50px"
                    @change="onChangeItem(item)">
                    <a-select-option value="%">%</a-select-option>
                    <a-select-option :value="getDiscountCurrency(item.input_currency_id)">
                      {{ getDiscountCurrency(item.input_currency_id) }}
                    </a-select-option>
                  </a-select>
                </td>
                <td>
                  <input v-if="item.incentive_type == '%'" ref="incentiveRate" type="number"
                    v-model.number="item.input_incentive_rate" class="form-control" @change="onChangeItem(item)" />
                  <ts-currency-converter-input v-else :input_amount.sync="item.input_incentive_rate"
                    :amount.sync="item.incentive_rate" :input_currency_id.sync="item.input_currency_id"
                    :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                    :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 120px;" />
                </td>
                <td class="text-center">
                  <a href="#" class="ts-text-red-700 hover:ts-text-red-700" @click.prevent="removeItem(index)">
                    <i class="fa fa-trash"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </fieldset>
    <!-- show product list pop-up -->
    <a-modal v-if="show_form" v-model="show_form" :title="$t('promotion.buyProduct')" :maskClosable="false"
      :footer="null" width="900px">
      <ProductList v-model="model" />
    </a-modal>
    <!-- show apply all pop-up -->
    <a-modal v-if="show_apply_all" v-model="show_apply_all" :title="$t('promotion.applyAll')" :maskClosable="false"
      :footer="null" width="700px">
      <div class="table-ui-detail ts-space-y-2">
        <table>
          <thead>
            <tr>
              <th width="25%">{{ $t('promotion.discountType') }}</th>
              <th width="25%">{{ $t('promotion.discountRate') }}</th>
              <th width="25%">{{ $t('promotion.incentiveType') }}</th>
              <th width="25%">{{ $t('promotion.incentiveRate') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <a-select v-model="model_apply_all.discount_type" class="ts-w-full" style="min-width: 50px"
                  @change="onChangeItem(model_apply_all)">
                  <a-select-option value="%">%</a-select-option>
                  <a-select-option :value="getDiscountCurrency(model_apply_all.input_currency_id)">
                    {{ getDiscountCurrency(model_apply_all.input_currency_id) }}
                  </a-select-option>
                </a-select>
              </td>
              <td>
                <input v-if="model_apply_all.discount_type == '%'" ref="discountRate" type="number"
                  v-model.number="model_apply_all.input_discount_rate" class="form-control"
                  @change="onChangeItem(model_apply_all)" />
                <ts-currency-converter-input v-else :input_amount.sync="model_apply_all.input_discount_rate"
                  :amount.sync="model_apply_all.discount_rate"
                  :input_currency_id.sync="model_apply_all.input_currency_id"
                  :currency_id.sync="model_apply_all.currency_id" :fx_rate.sync="model_apply_all.fx_rate"
                  :fx_rate_ratio.sync="model_apply_all.fx_rate_ratio" style="min-width: 120px;" />
              </td>
              <td>
                <a-select v-model="model_apply_all.incentive_type" class="ts-w-full" style="min-width: 50px"
                  @change="onChangeItem(model_apply_all)">
                  <a-select-option value="%">%</a-select-option>
                  <a-select-option :value="getDiscountCurrency(model_apply_all.input_currency_id)">
                    {{ getDiscountCurrency(model_apply_all.input_currency_id) }}
                  </a-select-option>
                </a-select>
              </td>
              <td>
                <input v-if="model_apply_all.incentive_type == '%'" ref="incentiveRate" type="number"
                  v-model.number="model_apply_all.input_incentive_rate" class="form-control"
                  @change="onChangeItem(model_apply_all)" />
                <ts-currency-converter-input v-else :input_amount.sync="model_apply_all.input_incentive_rate"
                  :amount.sync="model_apply_all.incentive_rate"
                  :input_currency_id.sync="model_apply_all.input_currency_id"
                  :currency_id.sync="model_apply_all.currency_id" :fx_rate.sync="model_apply_all.fx_rate"
                  :fx_rate_ratio.sync="model_apply_all.fx_rate_ratio" style="min-width: 120px;" />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
            <ts-button @click.prevent="() => show_apply_all = false">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button @click.prevent="onApply" color="primary">
              {{ $t('apply') }}
            </ts-button>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './modal-popup/incentive-by-item-product-list.vue'
export default {
  name: 'buyItemFreeItemCondition',
  props: ['value', 'validate'],
  components: {
    ProductList,
  },
  data() {
    return {
      errors: new Errors(),
      show_form: false,
      show_apply_all: false,
      model: {},
      model_apply_all: {
        currency_id: 1,
        input_currency_id: 1,
        fx_rate: 1,
        fx_rate_ratio: 1,
        discount_type: '%',
        discount_rate: 0,
        input_discount_rate: 0,
        incentive_type: '%',
        incentive_rate: 0,
        input_incentive_rate: 0
      },
    }
  },
  created() {
    this.model = this.value
    this.setDefaultCurrency()
  },
  computed: {
    ...mapState('promotion/incentiveByItem', ['formViewDatas']),
  },
  methods: {
    onApplyAll() {
      this.show_apply_all = true
    },
    onApply() {
      this.model.condition.forEach(product => {
        product.input_currency_id = this.model_apply_all.input_currency_id
        product.fx_rate = this.model_apply_all.fx_rate
        product.fx_rate_ratio = this.model_apply_all.fx_rate_ratio
        product.discount_type = this.model_apply_all.discount_type
        product.discount_rate = this.model_apply_all.discount_rate
        product.input_discount_rate = this.model_apply_all.input_discount_rate
        product.incentive_type = this.model_apply_all.incentive_type
        product.incentive_rate = this.model_apply_all.incentive_rate
        product.input_incentive_rate = this.model_apply_all.input_incentive_rate
      });
    },
    setDefaultCurrency() {
      let default_currency = this.$store.state.exchangeRate.currency.formViewDatas['default']

      this.model_apply_all.currency_id = default_currency
        ? default_currency.currency_id
        : null
      this.model_apply_all.input_currency_id = default_currency
        ? default_currency.currency_id
        : null
      this.model_apply_all.fx_rate = 1
      this.model_apply_all.fx_rate_ratio = 1
      this.model_apply_all.discount_type = '%'
      this.model_apply_all.discount_rate = 0
      this.model_apply_all.input_discount_rate = 0
      this.model_apply_all.incentive_type = '%'
      this.model_apply_all.incentive_rate = 0
      this.model_apply_all.input_incentive_rate = 0
    },
    addItem() {
      this.show_form = true
    },
    removeItem(index) {
      this.model.condition.splice(index, 1)
    },
    getDiscountCurrency(input_currency_id) {
      if (this.formViewDatas['currency']) {
        let currency = this.formViewDatas['currency'].find(
          el => el.currency_id == input_currency_id
        )
        return currency ? currency.currency_symbol : null
      }
      return null
    },
    getProduct(product_id) {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products'].find(el => el.product_id == product_id)
      }
    },
    onChangeItem(product) {
      if (product.discount_type == '%') {
        product.discount_rate = product.input_discount_rate
      } else {
        product.discount_type = this.getDiscountCurrency(product.input_currency_id)
        product.discount_rate = product.input_discount_rate * product.fx_rate_ratio
      }

      if (product.incentive_type == '%') {
        product.incentive_rate = product.input_incentive_rate
      } else {
        product.incentive_type = this.getDiscountCurrency(product.input_currency_id)
        product.incentive_rate = product.input_incentive_rate * product.fx_rate_ratio
      }
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>